import * as React from "react";
import { EmailAddressType } from "../../../../../../Wrap/Constants/Enums/EmailAddressType";
import { CustomerEmailAddress } from "../../../../../../Wrap/Models/Models/Customer/CustomerEmailAddress";
import { CustomerPhoneNumber } from "../../../../../../Wrap/Models/Models/Customer/CustomerPhoneNumber";
import { CountryCodeMap } from "../../../../../Shared/Entities/Maps/CountryCodeMap";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { PhoneNumberTypeMap } from "../../ClientRecord/Resource/Contents";
import { prepareTypography } from "../../Common/Review/ReviewParser";
import { fieldDefaultValue } from "../Resource/CustomerMergeHelper";

interface IContactInformationProps {
    eData: Array<CustomerEmailAddress>;
    pData: Array<CustomerPhoneNumber>;
    otherpData: Array<CustomerPhoneNumber>;
}

const phoneNumberConfig = (pData: Array<CustomerPhoneNumber>) => {
    const result = [];
    pData.forEach((e) => {
        result.push(
            { title: "Phone type", data: fieldDefaultValue(PhoneNumberTypeMap[e?.PhoneNumberType]) },
            { title: "Country", data: fieldDefaultValue(CountryCodeMap.getString(e?.PhoneNumber?.Country)) },
            {
                title: "Number",
                data: fieldDefaultValue((e?.PhoneNumber?.AreaCode || "") + (e?.PhoneNumber?.Number || "")),
            }
        );
    });
    return result;
};

const emailConfig = (eData: Array<CustomerEmailAddress>) => {
    const primaryEmail = eData?.find((e) => {
        return e?.EmailAddressType == EmailAddressType.Primary;
    });
    const otherEmail = eData?.find((e) => {
        return e?.EmailAddressType == EmailAddressType.Other;
    });
    return [
        {
            title: "Email - primary",
            data: fieldDefaultValue(primaryEmail?.EmailAddress),
        },
        {
            title: "Email - other",
            data: fieldDefaultValue(otherEmail?.EmailAddress),
        },
    ];
};

const fullConfig = (pData: Array<CustomerPhoneNumber>, eData: Array<CustomerEmailAddress>) => {
    const pDataResult = phoneNumberConfig(pData);
    const eDataResult = emailConfig(eData);

    return pDataResult.concat(eDataResult);
};

export const ContactInformation = (props: IContactInformationProps) => {
    const phoneNumberTypeFrompData = props?.pData?.map((e) => e?.PhoneNumberType);
    const phoneNumberTypeFromOtherpData = props?.otherpData?.map((e) => e?.PhoneNumberType);

    const phoneNumberTypeSet = new Set();
    phoneNumberTypeFrompData?.forEach((e) => phoneNumberTypeSet.add(e));
    phoneNumberTypeFromOtherpData?.forEach((e) => phoneNumberTypeSet.add(e));

    const _sortedPhoneNumber = [];
    for (const ele of phoneNumberTypeSet) {
        const _data1 = props?.pData?.find((e) => e?.PhoneNumberType == ele);
        if (_data1) {
            _sortedPhoneNumber.push(_data1);
        } else {
            // need create empty object
            _sortedPhoneNumber.push({ PhoneNumberType: null, PhoneNumber: null });
        }
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h3>
                        <u>Contact information</u>
                    </h3>
                </div>
            </div>
            <Typography {...prepareTypography(fullConfig(_sortedPhoneNumber, props?.eData), 1, "common")} />
        </>
    );
};
